module.exports = __webpack_public_path__ + "static/media/users-icon.158de6ec.svg";